import { memo, useCallback } from 'react';

import Box from '@zenbusiness/zui/Box';
import Heading from '@zenbusiness/zui/Heading';
import Skeleton from '@zenbusiness/zui/Skeleton';
import Stack from '@zenbusiness/zui/Stack';
import PropTypes from 'prop-types';

import useBreakpoints from '#client/hooks/useBreakpoints';

import {
  GridStyled,
  IconAreaStyled,
  GreenCircle,
  TitleAreaStyled
} from './InfoCardSkeleton.styles';

const InfoCardSkeleton = ({ title, icon, totalLeftFields = 1, totalRightFields = 1 }) => {
  const {
    sizes: { isDesktop }
  } = useBreakpoints();

  const renderFields = useCallback(
    (totalFields) =>
      Array.from({ length: totalFields }, (_, key) => (
        <Stack
          key={key}
          spacing={isDesktop ? '8px' : '4px'}
        >
          <Skeleton
            height={15}
            width="60%"
          />
          <Skeleton height={isDesktop ? 20 : 15} />
        </Stack>
      )),
    [isDesktop]
  );

  return (
    <GridStyled>
      <IconAreaStyled>
        <GreenCircle>{icon}</GreenCircle>
      </IconAreaStyled>
      <TitleAreaStyled>
        <Heading
          size="2xl"
          weight="bold"
        >
          {title}
        </Heading>
      </TitleAreaStyled>
      <Box />
      <Stack
        direction={isDesktop ? 'row' : 'column'}
        marginY="20px"
        spacing="40px"
      >
        {/** Right data */}
        <Stack
          spacing="16px"
          width="100%"
        >
          {renderFields(totalRightFields)}
        </Stack>
        {/** Left data */}
        <Stack
          spacing="16px"
          width="100%"
        >
          {renderFields(totalLeftFields)}
        </Stack>
      </Stack>
    </GridStyled>
  );
};

InfoCardSkeleton.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  totalLeftFields: PropTypes.number,
  totalRightFields: PropTypes.number
};

export default memo(InfoCardSkeleton);
